import { memo, useMemo } from 'react';
import type { AIReceptionistEvent } from '@weave/schema-gen-ts/dist/schemas/phone-exp/phone-records-ext/call-path/v1/api.pb';
import { AIOutcome } from '@weave/schema-gen-ts/dist/shared/phone/v1/callrecord/enums.pb';
import { Trans, useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { DotRow, formatTime } from '../../utils/get-event-accordion-body';

export const AIReceptionistEventComponent = memo(({ enteredAt, exitedAt, actionType, reason }: AIReceptionistEvent) => {
  const { t } = useTranslation('calls');
  const { createdAtTime, endedAtTime } = useMemo(
    () => ({
      createdAtTime: formatTime(enteredAt),
      endedAtTime: formatTime(exitedAt),
    }),
    [enteredAt, exitedAt]
  );

  const showTransferedCallMessage = actionType === AIOutcome.AI_OUTCOME_ROUTE_TRANSFERRED;
  const reasonColor = actionType === AIOutcome.AI_OUTCOME_FATAL ? 'error' : 'light';
  const callEndedByAi = actionType === AIOutcome.AI_OUTCOME_END_CALL;

  return (
    <>
      <div>
        <DotRow
          message={
            <Trans t={t}>
              <Text weight='bold' size='medium' as='span'>
                AI Receptionist
              </Text>{' '}
              <Text as='span' size='medium'>
                answers the call
              </Text>
            </Trans>
          }
          time={createdAtTime}
          isLast={!showTransferedCallMessage}
        />
        {showTransferedCallMessage && (
          <DotRow
            message={
              <Trans t={t}>
                <Text weight='bold' size='medium' as='span'>
                  AI Receptionist
                </Text>{' '}
                <Text as='span' size='medium'>
                  transfers call
                </Text>
              </Trans>
            }
            time={endedAtTime}
            isLast
          />
        )}
      </div>

      {!callEndedByAi && (
        <Text color={reasonColor} textAlign='left' size='small' css={{ paddingTop: theme.spacing(2) }}>
          {reason}
        </Text>
      )}
    </>
  );
});

AIReceptionistEventComponent.displayName = 'AIReceptionistEventComponent';
